import React, { useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CustomerApi from '../../../../api/customer';
import { useAuth } from '../../../../auth-context/auth.context';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import { CustomerAdminValidationSchema } from 'formValidations/customerAdminFormValidations';

export default function PopModal(props) {
  const currentUser = props.currentUser;
  const userId = currentUser.id;
  const { user } = useAuth();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);
  const toast = useToast();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const api = await CustomerApi.Update({
        userId,
        ...values,
      });
      const response = api.data;
      if (response.status_code === 200) {
        toast({
          title: response.message || 'Successfully Updated',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toast({
          title: response.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      toast({
        title: 'Unable to Update',
        status: 'error',
        duration: 1000,
        isClosable: true,
        position: 'top',
      });
      console.log(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Button onClick={onOpen} disabled={props.disabled}>
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={{
                name: currentUser.name || '',
                email: currentUser.email || '',
                phoneNumber: currentUser.phone_number || '',
                status: currentUser.status || '',
              }}
              validationSchema={CustomerAdminValidationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form noValidate>
                  <InputField
                    label='Name'
                    required={true}
                    name='name'
                    type='text'
                  />
                  <InputField
                    label='Email'
                    required={true}
                    name='email'
                    type='email'
                  />
                  <InputField
                    label='Phone Number'
                    required={true}
                    name='phoneNumber'
                    type='number'
                  />
                  <SelectField
                    label='Status'
                    required={true}
                    name='status'
                    options={[
                      { value: 'ACTIVE', label: 'Active' },
                      { value: 'INACTIVE', label: 'Inactive' },
                      { value: 'UNVERIFIED', label: 'Unverified' },
                      { value: 'BLOCKED', label: 'Blocked' },
                    ]}
                  />
                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}
                    >
                      Update
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
